import React, { useState } from 'react'
import addIcon from '../../assets/images/icons/add.svg';
import { Link } from "react-router-dom";
import { Radio, Select, Col, Row, Input, Checkbox, Tooltip, Modal, Empty } from "antd";
import backButton from '../../assets/images/back_button_arrow.svg';
import siteIcon from '../../assets/images/icons/site.svg';

function resetFormView() { };

const SiteCreateZone = ({ handlePageViewChange }) => {

    const onChange = (value) => {
        console.log(`selected ${value}`);
    };
    const onSearch = (value) => {
        console.log('search:', value);
    };

    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}>
                                <img src={siteIcon} alt="USP" /> Demand
                            </Link>
                        </li>
                        <li className="">Freewheel</li>
                        <li className="">Zones</li>
                        <li className="primary">New Site</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}
                        />
                        <h1 className="heading">
                            Create Zone
                        </h1>
                    </div>
                </div>
                <div className="container_box--content pt_20">
                    <div className="container_box--width">

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Choose Site</label>
                                    <p className="sub_text">Select site for zone creation.</p>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                <label className="form_label">Site Name </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>


                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>General details</label>
                                    <p className="sub_text">Please enter site details</p>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Type *</label>
                                                <Input className='form_control basic' disabled autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Name *</label>
                                                <Input className='form_control basic ' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Description</label>
                                                <Input className='form_control basic form_control_h --80' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Device *</label>
                                                <Input className='form_control basic' disabled autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                                        <span className="form_label">
                                                            VAST Direct
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Positioning *</label>
                                                <Input className='form_control basic ' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                                        <span className="form_label">
                                                            Overlay
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Integration Type * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="Select a person"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                                        <span className="form_label">
                                                            VPAID
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Tags *</label>
                                                <Input className='form_control basic' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Passback URL</label>
                                                <Input className='form_control basic form_control_h --80' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group">
                                                <label className="form_label">
                                                    Gender
                                                </label>
                                                <Radio.Group className="form_radio equal_space">
                                                    <Radio className="radio_btn" value="Website">
                                                        Allowed
                                                    </Radio>
                                                    <Radio className="radio_btn" value="Inapp">
                                                        Allowed but under condition
                                                    </Radio>
                                                    <Radio className="radio_btn" value="CTV">
                                                        Disallowed
                                                    </Radio>
                                                </Radio.Group>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                                        <span className="form_label">
                                                            HTTPS only
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                                        <span className="form_label">
                                                            Live event
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value mb-0">
                                                <label className="form_label">Auction Type * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="Select a person"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Floor Prices</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Floor Price Type </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="Select a person"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group mb-0 prefixIconCss_d2">
                                                <label className="form_label">Amount</label>
                                                <Input className='form_control basic' placeholder='0' autocomplete="off" prefix={'$'} />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>


                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Frequency Capping</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                                        <span className="form_label">
                                                            Enabled
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Limit to *</label>
                                                <Input className='form_control basic' autocomplete="off" placeholder='0' suffix={
                                                    <em className='input_inside_text_d2'>impression(s)</em>
                                                } />
                                                <span className="error_content"> </span>
                                            </div>
                                            <Row gutter={8}>
                                                <Col span={8}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className="form_label">Per *</label>
                                                        <Input className='form_control basic' autocomplete="off" placeholder='0' suffix={
                                                            <em className='input_inside_text_d2'>hour(s)</em>
                                                        } />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                                <Col span={8}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className="form_label invisible">Per *</label>
                                                        <Input className='form_control basic' autocomplete="off" placeholder='0' suffix={
                                                            <em className='input_inside_text_d2'>minute(s)</em>
                                                        } />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                                <Col span={8}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className="form_label invisible">Per *</label>
                                                        <Input className='form_control basic' autocomplete="off" placeholder='0' suffix={
                                                            <em className='input_inside_text_d2'>second(s)</em>
                                                        } />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Player</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <div className="form_content_block--group mb_0">
                                                <label className="form_label">Width *</label>
                                                <Input className='form_control basic' value={1920} autocomplete="off" />
                                            </div>
                                            <span className="error_content"></span>
                                        </Col>
                                        <Col span={12}>
                                            <div className="form_content_block--group mb_0">
                                                <label className="form_label">Height *</label>
                                                <Input className='form_control basic' value={1080} autocomplete="off" />
                                                <span className="error_content"></span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Skip AD Button</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container mb_0">
                                    <Row gutter={16}>
                                        <Col className='w_100'>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className="form_content_block--group m-0">
                                                    <div className="primary_checkbox">
                                                        <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                                            <span className="form_label">
                                                                Enabled
                                                            </span>
                                                        </Checkbox>
                                                    </div>
                                                </div>
                                                <div>
                                                    <em className='input_inside_text_d2 p-0 text-nowrap'>This "skip ad button" only works with freewheel SDK.</em>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        <button className="w_120_d2 btn btn_white_outline w_fit_content"> Discard </button>
                        <button className="w_120_d2 btn btn_primary w_fit_content">Create Zone</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SiteCreateZone
